window.compositorApp = {
    controller: () => {},
    directive: () => {},
};